import { Injectable } from "@angular/core";


@Injectable()

export class GenericFeatureService {
    public getCategoryIdByNameAndCurrentCategory(name: string, currentCategoryId?: string): string {
        return "";
    }
}